import { Grid } from '@material-ui/core';
import { FC } from 'react';
import { IFormComponentProps } from 'shared/interfaces/IModalForm';
import RightFormComponent from './RightFormComponent/RightFormComponent';

const FormComponent: FC<IFormComponentProps> = ({
  handleOnDragEnd,
  handleUploadImages,
  handleRemoveImages,
  uploadedFiles,
  filesToBeSaved,
  handleFilesToBeSaved,
  formComponent,
  trigger,
}) => {
  const showCheckBox = trigger?.toLowerCase() === 'dog' || trigger?.toLowerCase() === 'cat' ? 498 : 438;
  return (
    <Grid container style={{ flexGrow: 1, height: '100%' }} spacing={2}>
      <Grid item xs={12} sm={6}>
        {formComponent}
      </Grid>
      <Grid
        item
        xs={12}
        sm={6}
        style={{
          minHeight: 438,
          maxHeight: showCheckBox,
          overflow: 'auto',
        }}
      >
        <RightFormComponent
          filesToBeSaved={filesToBeSaved}
          handleFilesToBeSaved={handleFilesToBeSaved}
          uploadedFiles={uploadedFiles}
          handleRemoveImages={handleRemoveImages}
          handleUploadImages={handleUploadImages}
          handleOnDragEnd={handleOnDragEnd}
        />
      </Grid>
    </Grid>
  );
};

export default FormComponent;
